// NOTE this is type of messages that come from the websockets
// onmessage (msg) => msg.data.type

export const WEBSOCKET_MESSAGING_EVENT_TYPES = {
  ENTER_CHAT: "enter_chat",
  ENTER_CHAT_V2: "enter_chat_v2",
  CHAT: "chat", //message type for sending a chat message
  CHAT_RECEIVED: "chat_received",
} as const;
